/**
 *  業者・利用者取得 リクエスト
 */
export interface TraderAndDonorSearchRequest {
  traderCode: string | undefined
  donorCode: string | undefined
}

export const traderAndDonorDefaultRequest = (): TraderAndDonorSearchRequest => ({
  traderCode: '',
  donorCode: ''
})

export function TraderAndDonorSearchRequestToJSON(
  value: TraderAndDonorSearchRequest
): any {
  return {
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined
  }
}

/**
 * 業者・利用者作成 リクエスト
 */
export interface TraderAndDonorCreateRequest {
  traderCode: string | undefined
  donorCode: string | undefined
  name: string
  shortName: string
  rate: string
  phoneType: string
  phone: string
  zipCode: string
  address: string
  memo: string
}

export const traderAndDonorCreateDefaultRequest = (): TraderAndDonorCreateRequest => ({
  traderCode: '',
  donorCode: '',
  name: '',
  shortName: '',
  rate: '',
  phoneType: '',
  phone: '',
  zipCode: '',
  address: '',
  memo: ''
})

export function TraderAndDonorCreateRequestToJSON(
  value: TraderAndDonorCreateRequest
): any {
  return {
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    name: value.name !== '' ? value.name : undefined,
    short_name: value.shortName !== '' ? value.shortName : undefined,
    rate: value.rate !== '' ? value.rate : undefined,
    phone_type: value.phoneType !== '' ? value.phoneType : undefined,
    phone: value.phone !== '' ? value.phone : undefined,
    zip_code: value.zipCode !== '' ? value.zipCode : undefined,
    address: value.address !== '' ? value.address : undefined,
    memo: value.memo !== '' ? value.memo : undefined
  }
}

/**
 * 業者・利用者更新 リクエスト
 */
export interface TraderAndDonorUpdateRequest {
  traderCode: string | undefined
  donorCode: string | undefined
  name: string
  shortName: string
  rate: string
  phoneType: string
  phone: string
  zipCode: string
  address: string
  memo: string
  revision: number | null
}

export const traderAndDonorUpdateDefaultRequest = (): TraderAndDonorUpdateRequest => ({
  traderCode: '',
  donorCode: '',
  name: '',
  shortName: '',
  rate: '',
  phoneType: '',
  phone: '',
  zipCode: '',
  address: '',
  memo: '',
  revision: null
})

export function TraderAndDonorUpdateRequestToJSON(
  value: TraderAndDonorUpdateRequest
): any {
  return {
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    name: value.name !== '' ? value.name : undefined,
    short_name: value.shortName !== '' ? value.shortName : undefined,
    rate: value.rate !== '' ? value.rate : undefined,
    phone_type: value.phoneType !== '' ? value.phoneType : undefined,
    phone: value.phone !== '' ? value.phone : undefined,
    zip_code: value.zipCode !== '' ? value.zipCode : undefined,
    address: value.address !== '' ? value.address : undefined,
    memo: value.memo !== '' ? value.memo : undefined,
    revision: value.revision !== null ? value.revision : undefined
  }
}
